var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-deadline-form',{attrs:{"next-step-path":"SelfService-ReportDamage-Counterparty","previous-step-path":"SelfService-ReportDamage-DocumentUpload"}})}
var staticRenderFns = []

export { render, staticRenderFns }